import api from '../utils/api'
import { API_ROOT } from '../constants'

export const createSubscription = ({
  email,
  name,
  paymentMethodId,
  priceId,
  studentData,
  paymentGateway,
  source,
  upgradeReason,
  productId,
  couponId,
  verifyAccountExistence,
  setupIntentId,
  businessDetails,
  // Individual business details fields for easier access in backend
  organization,
  vatId,
  isBusinessAccount,
  // Tax ID for Stripe customer tax ID
  tax_id,
  // Country code for determining tax ID type
  tax_id_country,
  // Address components for Stripe metadata and invoice
  addressLine1,
  addressLine2,
  addressCity,
  addressState,
  addressPostalCode,
  addressCountry,
  headers
}) => {
  const reqData = {
    email,
    name,
    paymentMethodId,
    priceId,
    studentData,
    paymentGateway,
    source,
    upgradeReason,
    productId,
    couponId,
    verifyAccountExistence,
    setupIntentId,
    businessDetails,
    // Include individual fields for easier backend processing
    organization,
    vatId,
    isBusinessAccount,
    // Include tax ID for Stripe customer tax ID
    tax_id,
    // Include country code for determining tax ID type
    tax_id_country,
    // Include address components
    addressLine1,
    addressLine2,
    addressCity,
    addressState,
    addressPostalCode,
    addressCountry
  }
  const route = paymentGateway === 'PADDLE' ? 'create-sub-paddle' : 'create-subscription'
  return api.post(`${API_ROOT}/${route}`, reqData, headers).then((result) => {
    if (result.error) {
      throw result
    }
    return result
  })
}

export const createPaymentMethod = (stripe, cardElement, billing_details) => {
  // Make sure we don't include vatId in billing_details as Stripe doesn't accept it
  const { vatId, ...validBillingDetails } = billing_details

  return stripe.createPaymentMethod({
    type: 'card',
    card: cardElement,
    billing_details: validBillingDetails
  })
}

export const createOneTimePayment = (stripe, clientSecret, card) =>
  stripe.confirmCardPayment(clientSecret, {
    payment_method: {
      card: card
    },
    setup_future_usage: 'off_session'
  })
